module.exports = __webpack_public_path__ + "static/SHOP-7f572453096a6a614a475404ec874fb2.png";